import { Component, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { AppState } from '@fcom/core/interfaces';
import { profileOrUndefinedIfNotLoggedIn } from '@fcom/core/selectors';
import { finShare } from '@fcom/rx/operators/finShare';
import { CorporateUserRole, Profile } from '@fcom/core-api/login';
import { ConfigService } from '@fcom/core/services';
import { Trip } from '@fcom/common/interfaces';
import { CorporateService } from '@fcom/common/services/corporate/corporate.service';
import { toISO8601 } from '@fcom/core/utils';
import { isCorporateAdmin } from '@fcom/common/login';

@Component({
  selector: 'fin-portal-home',
  templateUrl: './corporate-home.component.html',
  styleUrls: ['./corporate-home.component.scss'],
})
export class CorporateHomeComponent implements OnInit {
  description$: Observable<string>;
  profile$: Observable<Profile | undefined>;
  trip$: Observable<Trip>;
  showWidgets$: Observable<boolean>;
  showSafWidget$: Observable<boolean>;

  constructor(
    private store: Store<AppState>,
    private corporateService: CorporateService,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.profile$ = this.store.pipe(profileOrUndefinedIfNotLoggedIn(), finShare());
    this.trip$ = this.corporateService
      .getTrips({
        from: 0,
        size: 1,
        filter: {
          dateRange: {
            fromDate: toISO8601(new Date()),
            toDate: undefined,
          },
          myTrips: true,
        },
      })
      .pipe(
        map((tripsResponse) => tripsResponse.trips?.[0]),
        finShare()
      );
    this.showWidgets$ = this.profile$.pipe(map((userProfile) => userProfile?.isCorporate));
    this.showSafWidget$ = this.profile$.pipe(
      map((userProfile) => this.configService.cfg.enableCorporateSaf && isCorporateAdmin(userProfile))
    );
    this.description$ = this.profile$.pipe(
      map((profile) =>
        profile?.corporate?.userRole === CorporateUserRole.TRAVELLER
          ? 'CORPORATE.corporatePortal.home.description'
          : 'CORPORATE.corporatePortal.home.adminDescription'
      )
    );
  }
}
